import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { InlineTable, useColl, rd } from "./Inline";

export const OWN = [["propio", "Propio (nuestro)"], ["alquilado", "Alquilado"]];
export const UNIT = [["hora", "Por hora"], ["dia", "Por día"]];
export const PAY = [["hora", "Por hora"], ["dia", "Por día"], ["fijo", "Fijo por trabajo"], ["semana", "Fijo por semana"]];
const today = () => new Date().toLocaleDateString("en-CA");

export function EquipmentTab() {
  const c = useColl("heavy_equipment", { sort: "name" });
  const cols = [
    { k: "name", label: "Equipo", w: 170 }, { k: "kind", label: "Tipo", w: 130 }, { k: "serial", label: "Placa / serie", w: 120 },
    { k: "ownership", label: "Propiedad", opts: OWN, w: 150 }, { k: "owner_name", label: "Dueño (si es alquilado)", w: 160 },
    { k: "owner_phone", label: "Tel. dueño", type: "tel", w: 120 }, { k: "rental_rate", label: "Costo alquiler RD$", type: "number", w: 120 },
    { k: "rental_unit", label: "Alquiler", opts: UNIT, w: 110 }, { k: "client_rate", label: "Tarifa cliente RD$/hora", type: "number", w: 130 },
  ];
  return <InlineTable prefix="heq" cols={cols} rows={c.rows} save={c.save} del={(id) => c.del(id, "este equipo")} addLabel="Agregar equipo"
    onAdd={() => c.add({ name: "Nuevo equipo", ownership: "propio", rental_unit: "hora" })} empty="Aún no hay equipos. Agrega los que tienen." />;
}

export function OperatorsTab() {
  const c = useColl("heavy_operators", { sort: "name" });
  const cols = [
    { k: "name", label: "Nombre", w: 170 }, { k: "phone", label: "Teléfono", type: "tel", w: 130 }, { k: "email", label: "Email", type: "email", w: 170 },
    { k: "cedula", label: "Cédula", w: 130 }, { k: "pay_mode", label: "Forma de pago", opts: PAY, w: 170 }, { k: "pay_rate", label: "Tarifa RD$", type: "number", w: 110 },
  ];
  return <InlineTable prefix="hop" cols={cols} rows={c.rows} save={c.save} del={(id) => c.del(id, "este operador")} addLabel="Agregar operador"
    onAdd={() => c.add({ name: "Nuevo operador", pay_mode: "hora" })} empty="Aún no hay operadores." />;
}

export function TransportTab() {
  const c = useColl("heavy_transports", { sort: "-date" });
  const cols = [
    { k: "date", label: "Día", type: "date", w: 118 },
    { k: "equipment_name", label: "Equipo", w: 110 },
    { k: "carrier", label: "Quién lo transportó", w: 115 }, { k: "from_place", label: "Desde", w: 90 }, { k: "to_place", label: "Hasta", w: 90 },
    { k: "price", label: "Precio RD$", type: "number", w: 95 },
    { k: "status", label: "Estado", opts: [["cotizacion", "Cotización"], ["pagado", "Pagado"]], w: 105 },
    { k: "notes", label: "Notas", w: 80 },
  ];
  const sum = (s) => c.rows.filter((r) => r.status === s).reduce((a, r) => a + (r.price || 0), 0);
  return (
    <div className="space-y-3">
      <p className="text-sm text-slate-500">Solo los transportes en estado <b>Pagado</b> se suman a los gastos del Dashboard. Las cotizaciones quedan guardadas aparte.</p>
      <InlineTable prefix="htr" cols={cols} rows={c.rows} save={c.save} del={(id) => c.del(id, "este transporte")} addLabel="Agregar transporte"
        onAdd={() => c.add({ date: today(), status: "cotizacion" })} empty="Aún no hay transportes registrados."
        footer={c.rows.length > 0 && <tfoot><tr className="border-t bg-slate-50"><td colSpan={cols.length + 1} className="px-3 py-3 text-right text-sm"><span className="mr-6">Cotizaciones: <b className="font-mono-num" data-testid="htr-sum-quote">{rd(sum("cotizacion"))}</b></span>Pagado: <b className="font-mono-num text-[#FF3333]" data-testid="htr-sum-paid">{rd(sum("pagado"))}</b></td></tr></tfoot>} />
    </div>
  );
}

export function useOptions() {
  const [o, setO] = useState({ eq: [], ops: [], jobs: [], cats: {} });
  useEffect(() => {
    Promise.all([api.get("/admin/c/heavy_equipment", { params: { sort: "name" } }), api.get("/admin/c/heavy_operators", { params: { sort: "name" } }),
      api.get("/admin/c/heavy_jobs"), api.get("/admin/heavy/categories")])
      .then(([a, b, j, c]) => setO({ eq: a.data, ops: b.data, jobs: j.data, cats: c.data }));
  }, []);
  return o;
}

export function ExpensesTab({ jobId, equipmentId, onChange }) {
  const o = useOptions();
  const c = useColl("heavy_expenses", jobId ? { job_id: jobId, sort: "-date" } : { sort: "-date" });
  const cols = [
    { k: "date", label: "Fecha", type: "date", w: 140 },
    { k: "category", label: "Tipo de gasto", opts: Object.entries(o.cats).length ? Object.entries(o.cats) : [["combustible", "Combustible"]], w: 170 },
    { k: "equipment_id", label: "Equipo", opts: [["", "—"], ...o.eq.map((e) => [e.id, e.name])], w: 160 },
    ...(jobId ? [] : [{ k: "job_id", label: "Trabajo", opts: [["", "Sin trabajo"], ...o.jobs.map((j) => [j.id, `${j.code} · ${j.name || ""}`])], w: 190 }]),
    { k: "description", label: "Detalle", w: 200 }, { k: "amount", label: "Monto RD$", type: "number", w: 120 },
  ];
  const total = c.rows.reduce((a, r) => a + (r.amount || 0), 0);
  const wrap = (fn) => async (...a) => { const r = await fn(...a); onChange?.(); return r; };
  return <InlineTable prefix="hex" cols={cols} rows={c.rows} save={wrap(c.save)} del={wrap((id) => c.del(id, "este gasto"))} addLabel="Agregar gasto"
    onAdd={wrap(() => c.add({ date: today(), category: "combustible", job_id: jobId || "", equipment_id: equipmentId || "" }))} empty="Sin gastos registrados."
    footer={c.rows.length > 0 && <tfoot><tr className="border-t bg-slate-50"><td colSpan={cols.length - 1} className="px-3 py-3 text-right font-semibold">Total gastos</td><td className="px-3 py-3 font-mono-num font-bold" data-testid="hex-total">{rd(total)}</td><td /></tr></tfoot>} />;
}
